import React from "react";
import { LazyLoadImage } from 'react-lazy-load-image-component';
import config from "constants/config";

export const SingleValue = (props) => {

    let { children, innerProps, data } = props;

    return <div {...innerProps} className="dropdown-custom-item-value">
        <img src={`${config.CDN_FLAGS_URL}${data.value.toLowerCase()}.svg`} alt="" />
        {children}
    </div>
}


export const Option = (props) => {

    let { children, innerProps, data } = props;

    let tax = "22%";

    switch (data.value) {
        case "AT":
            tax = "25.0%";
            break;
        case "BE":
            tax = "25.0%";
            break;
        case "CZ":
            tax = "19.0%";
            break;
        case "CH":
            tax = "19.7%";
            break;
        case "DK":
            tax = "22.0%";
            break;
        case "EE":
            tax = "20.0%";
            break;
        case "FI":
            tax = "20.0%";
            break;
        case "FR":
            tax = "28.4%";
            break;
        case "DE":
            tax = "29.9%";
            break;
        case "GR":
            tax = "24.0%";
            break;
        case "HU":
            tax = "9.0%";
            break;
        case "IE":
            tax = "12.5%";
            break;
        case "IT":
            tax = "22.0%";
            break;
        case "LV":
            tax = "20.0%";
            break;
        case "LT":
            tax = "15.0%";
            break;
        case "LU":
            tax = "24.9%";
            break;
        case "NL":
            tax = "25.0%";
            break;
        case "PL":
            tax = "19.0%";
            break;
        case "PT":
            tax = "31.5%";
            break;
        case "SK":
            tax = "21.0%";
            break;
        case "SI":
            tax = "19.0%";
            break;
        case "ES":
            tax = "25.0%";
            break;
        case "SE":
            tax = "20.6%";
            break;
        case "TR":
            tax = "20.0%";
            break;
        case "GB":
            tax = "19.0%";
            break;
        case "IS":
            tax = "20.0%";
            break;
    }

    const ImagePlaceholder = () => <div style={{ width: "1.75rem", height: "1.125rem", borderRadius: ".25rem" }} className="skeleton skeleton3" ></div>;

    return <div {...innerProps} className={`${props.isSelected ? "selected" : ""} dropdown-custom-item-option`}>
        <LazyLoadImage placeholder={<ImagePlaceholder />} src={`${config.CDN_FLAGS_URL}${data.value.toLowerCase()}.svg`} alt="" />
        {data.label}
    </div>
};